import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Button, CloseButton, Modal } from 'react-bootstrap'
import { IoArrowUndo } from 'react-icons/io5'
import { useNavigate } from 'react-router'
import { getToken, URI } from '../../../Conexiones/Conexion'

export default function Permisos() {
    const navigate = useNavigate()
    const [listPermisos,setListPermisos]=useState([])
    const [catalogos,setCatalogos]=useState([])
    const [checked] = useState(true);
    const userPermiso = JSON.parse(sessionStorage.getItem('userPermiso')) 

    //PERMISOS PROYECTOS/OBRAS
    const [showProyectos, setShowProyectos] = useState(false);
    const handleCloseProyectos = () => setShowProyectos(false);

    //CATALOGOS
    const [showCatalogos, setShowCatalogos] = useState(false);
    const handleCloseCatalogos = () => setShowCatalogos(false);
    const handleShowCatalogos = (nomModulo) =>{
        if(nomModulo==="Catalogos"){
                if(catalogos.length===0){
                    setShowCatalogos(true);
                    getCatalogos(userPermiso)
                }else{
                    setShowCatalogos(true);
                }
        }else{
                setShowProyectos(true);
                getCatalogos(userPermiso)
        }
    }     

    
            useEffect (()=>{
                const getPermisos = async () =>{
                    const res = await axios.get(URI+'getCatalogoPermisos/'+userPermiso,{
                        headers: {
                            'Authorization': `Bearer ${getToken()}`
                        },
                        }).catch(
                            err =>{
                                if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                                    navigate('/')
                                }
                            }
                        )
                    setListPermisos(res.data)
                    console.log(res.data)
                }
                getPermisos();
        },[navigate,userPermiso]);

    const getCatalogos = async (id) =>{
        const res = await axios.get(URI+'catalogo/'+id,{
            headers: {
                'Authorization': `Bearer ${getToken()}`
            },
            }).catch(
                err =>{
                    if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                        navigate('/')
                    }
                }
            )
        setCatalogos(res.data)
        console.log(res.data)
    }

      //check catalogo
      const asignarCatalogo = async (idModulo,asignar) =>{
        const modificarCatalogo = catalogos.map ((listCatalogo) =>{
            if(listCatalogo.idModulo === idModulo){
                if(asignar===1){
                    return {
                        ...listCatalogo,
                        asignar:0
                    }
                }else{
                    return {
                        ...listCatalogo,
                        asignar:1
                    }
                }
                
            }
            return listCatalogo
        });
        setCatalogos(modificarCatalogo)
        console.log(modificarCatalogo)
    }

    //check permisos
    const asignarPermiso = async (idModulo,asignar) =>{
        const modificarPermiso = listPermisos.map ((listPermisos) =>{
            if(listPermisos.idModulo === idModulo){
                if(asignar===1){
                    return {
                        ...listPermisos,
                        asignar:0
                         }
                }else{
                    return {
                        ...listPermisos,
                        asignar:1
                    }
                }
                
            }
            return listPermisos
        });
        setListPermisos(modificarPermiso)
        console.log(modificarPermiso)
    }

    const regresar = () => {
        navigate('/inicio/Catalogos/Usuarios')
    }

  return (
      <>
       <div className="areas">
        <div >
                    <h3 className="tituloGastos"> PERMISOS</h3>
                    <IoArrowUndo title="REGRESAR" onClick={regresar} style={{position:'absolute', right:'40px', top:'60px', fontSize:'40px', cursor:'pointer', color:'#1A2E4F'}}/>
        </div> 
                <div >
                         {
                                listPermisos.length === 0 ? (<h3>AUN NO HAY REGISTROS</h3>):(
                                         <div >
                                                    <table className="table  text-uppercase" style={{textAlign:"center",marginTop:"20px"}}>
                                                        <thead  className="table-primary">
                                                            <tr>
                                                                <th > MODULO </th>
                                                                <th >ASIGNAR</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody >
                                                        {listPermisos.map( catalogo => {
                                                            return (
                                                                <tr key={catalogo.idModulo}>
                                                                    {(catalogo.nomModulo==="Catalogos" && catalogo.asignar===1) || (catalogo.nomModulo==="Proyectos" && catalogo.asignar===1)?(
                                                                         <td  onClick={() => handleShowCatalogos(catalogo.nomModulo)} >{catalogo.nomModulo}</td>)
                                                                         :(<td >{catalogo.nomModulo}</td>)}
                                                                    <td>
                                                                            <label className="switch">
                                                                                <input type="checkbox"  defaultChecked={catalogo.asignar===1?(checked):(!checked)} 
                                                                                onClick={()=>asignarPermiso(catalogo.idModulo,catalogo.asignar,catalogo.nomModulo)} />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                    </td>
                                                                    {/*<td>
                                                                            <div className="btn iconoH"  onClick={() => handleShowCatalogo(user,catalogo.nomModulo)}  style={{display:mostrarIcono(catalogo.nomModulo,catalogo.asignar)}}>
                                                                                <span><BsFillPlusCircleFill/></span>
                                                                            </div> 
                                                                    </td>*/}
                                                                    </tr>
                                                            )})
                                                        }
                                                        </tbody>
                                                    </table>
                                            </div>
                                           )
                                    }
                                        
                                   {/* <Col xs={12} md={6}>
                                                <div style={{textAlign:"center",display:"none"}} id="containerTabla" >
                                                    <table  className="table  text-uppercase" >
                                                        <thead  className="table-primary">
                                                            <tr>
                                                                <th >ASIGNAR</th>
                                                                <th > permiso </th>
                                                                <th > acciones </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody >
                                                        {catalogos.map( catalogo => {
                                                            return (
                                                                <tr key={catalogo.idModulo}>
                                                                            <td>
                                                                                <label className="switch">
                                                                                    <input type="checkbox"  defaultChecked={catalogo.asignar===1?(checked):(!checked)} 
                                                                                    onClick={()=>asignarCatalogo(catalogo.idModulo,catalogo.asignar)} />
                                                                                    <span className="slider round"></span>
                                                                                </label>
                                                                            </td>
                                                                            <td >{catalogo.nomModulo}</td>
                                                                            <td >
                                                                                <input disabled type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                            </td>
                                                                    </tr>
                                                            )})
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                    </Col>*/}
                </div>                     
        </div>
        
        {/*ASIGNAR CATALOGOS*/}
        <Modal  show={showCatalogos}  onHide={handleCloseCatalogos} id="modal-catalogos">
                                <Modal.Header className=' btncolor'>
                                    <Modal.Title>ASIGNAR PERMISOS</Modal.Title>
                                    <CloseButton onClick={handleCloseCatalogos} style={{backgroundColor:"white"}} />
                                </Modal.Header>
                                <form >
                                    <Modal.Body  style={{textAlign:'left', marginTop:'10px'}}>
                                                <div style={{textAlign:"center"}} id="containerTabla" >
                                                    <table  className="table  text-uppercase" >
                                                        <thead  className="table-primary">
                                                            <tr>
                                                                <th >ASIGNAR</th>
                                                                <th > permiso </th>
                                                                <th > acciones </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody >
                                                        {catalogos.map( catalogo => {
                                                            return (
                                                                <tr key={catalogo.idModulo}>
                                                                            <td>
                                                                                <label className="switch">
                                                                                    <input type="checkbox"  defaultChecked={catalogo.asignar===1?(checked):(!checked)} 
                                                                                    onClick={()=>asignarCatalogo(catalogo.idModulo,catalogo.asignar)} />
                                                                                    <span className="slider round"></span>
                                                                                </label>
                                                                            </td>
                                                                            <td >{catalogo.nomModulo}</td>
                                                                            <td >
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                            </td>
                                                                    </tr>
                                                            )})
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                    </Modal.Body>
                                <Modal.Footer>
                                    <Button type="button" className="btn btn-secondary" onClick={handleCloseCatalogos}>CANCELAR</Button>                                               
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                     
                                </Modal.Footer>
                                </form>
        </Modal>
        
        {/*ASIGNAR CATALOGOS (PROYECTOS/OBRAS)*/}
        <Modal  show={showProyectos}  onHide={handleCloseProyectos} id="modal-permisos-obras">
                                <Modal.Header className=' btncolor'>
                                    <Modal.Title>ASIGNAR PERMISOS</Modal.Title>
                                    <CloseButton onClick={handleCloseProyectos} style={{backgroundColor:"white"}} />
                                </Modal.Header>
                                <form >
                                    <Modal.Body  style={{textAlign:'left', marginTop:'10px'}}>
                                                <div style={{textAlign:"center"}} id="containerTabla" >
                                                    <table  className="table  text-uppercase" >
                                                        <thead  className="table-primary">
                                                            <tr>
                                                                <th >ASIGNAR</th>
                                                                <th > permiso </th>
                                                                <th > acciones </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody >
                                                        {catalogos.map( catalogo => {
                                                            return (
                                                                <tr key={catalogo.idModulo}>
                                                                            <td>
                                                                                <label className="switch">
                                                                                    <input type="checkbox"  defaultChecked={catalogo.asignar===1?(checked):(!checked)} 
                                                                                    onClick={()=>asignarCatalogo(catalogo.idModulo,catalogo.asignar)} />
                                                                                    <span className="slider round"></span>
                                                                                </label>
                                                                            </td>
                                                                            <td >{catalogo.nomModulo}</td>
                                                                            <td >
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                                <input type="checkbox" ></input>
                                                                            </td>
                                                                    </tr>
                                                            )})
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>
                                    </Modal.Body>
                                <Modal.Footer>
                                    <Button type="button" className="btn btn-secondary" onClick={handleCloseCatalogos}>CANCELAR</Button>                                               
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                     
                                </Modal.Footer>
                                </form>
        </Modal>
      </>
  )
}
